import { render, staticRenderFns } from "./DownloadResourceRQ.vue?vue&type=template&id=591f1ba4&"
import script from "./DownloadResourceRQ.vue?vue&type=script&lang=js&"
export * from "./DownloadResourceRQ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports